import React, { useContext, useState, useEffect, useRef } from 'react';
import { AuthContext } from '../authContext/auth';
import { Link, useNavigate } from 'react-router-dom';
import './header.css';
import Profile from '../images/profile.jpeg';

const Header = () => {
  const { isLoggedIn, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [showLogoutBanner, setShowLogoutBanner] = useState(false);
  const [showLogoutMessage, setShowLogoutMessage] = useState(false);
  const dropdownRef = useRef(null);

  const handleRedirect = (path) => {
    setTimeout(() => {
      navigate(path);
    }, 2000);
  };

  const handleLogout = () => {
    logout();
    setShowLogoutBanner(false);
    setShowLogoutMessage(true);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowLogoutBanner(false);
    }
  };

  useEffect(() => {
    let timeout;
    if (showLogoutMessage) {
      timeout = setTimeout(() => {
        setShowLogoutMessage(false);
      }, 2000);
    }
    return () => clearTimeout(timeout);
  }, [showLogoutMessage]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-black">
      <div className="container">
        {showLogoutMessage && (
          <div className="logout-message">Successfully logged out</div>
        )}
        <Link className="navbar-brand" to="/" style={{ fontWeight: 'bold' }}>
          <img
            src="https://i.pinimg.com/474x/71/89/88/718988215800391b6050182a28ca6810.jpg"
            alt="Logo"
          />
          Dangoo
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {isLoggedIn ? (
            <div className="user-info" ref={dropdownRef}>
              <div className="circular-frame" onClick={handleLogout}>
                <img
                  src={Profile}
                  alt="User Profile"
                  className="circular-picture"
                />
                {showLogoutBanner && (
                  <div className="logout-banner">
                    <button className="logout-button" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              <button
                className="btn btn-secondary"
                onClick={() => handleRedirect('/page')}
              >
                Login
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => handleRedirect('/signup')}
              >
                Register
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;